import { Map } from 'immutable';

import * as ActionDefinitions from './actionDefinitions';

const initialState = new Map();

const headerLogin = (state = initialState, action) => {
  switch(action.type) {
    case ActionDefinitions.SET_IS_LOGGED:
      return state.set('isLogged', true);
    default:
      return state;
  }
};

export default headerLogin;
